/**
 * PDC Installment Wise Table Component
 * Displays installment-wise post-dated cheque details
 */
import React, { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import LoadingComponent from '../../loadingComponent';

export class PDCInstallmentWiseTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pdcData: [],
            isLoading: false
        };
    }

    componentDidMount() {
        this.processPDCData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.pdcData !== this.props.pdcData) {
            this.processPDCData();
        }
    }

    processPDCData() {
        const { pdcData } = this.props;
        // Process PDC data here when API integration is ready
        this.setState({
            pdcData: pdcData || [],
            isLoading: false
        });
    }

    formatCurrency = (value) => {
        if (!value) return '₹0.00';
        return `₹${parseFloat(value).toFixed(2)}`;
    };

    // Column body templates
    installmentNameBodyTemplate = (rowData) => {
        return <span>{rowData.installmentName || 'N/A'}</span>;
    };

    feeAmountBodyTemplate = (rowData) => {
        return <span>{this.formatCurrency(rowData.feeAmount)}</span>;
    };

    concessionBodyTemplate = (rowData) => {
        return <span>{this.formatCurrency(rowData.concession)}</span>;
    };

    netAmountBodyTemplate = (rowData) => {
        return <span>{this.formatCurrency(rowData.netAmount)}</span>;
    };

    nonGSTPayableBodyTemplate = (rowData) => {
        return <span>{this.formatCurrency(rowData.nonGSTPayable)}</span>;
    };

    gstPayableBodyTemplate = (rowData) => {
        return <span>{this.formatCurrency(rowData.gstPayable)}</span>;
    };

    gstOnBodyTemplate = (rowData) => {
        return <span>{this.formatCurrency(rowData.gstOn)}</span>;
    };

    totalBodyTemplate = (rowData) => {
        return <span>{this.formatCurrency(rowData.total)}</span>;
    };

    actualPaidBodyTemplate = (rowData) => {
        return <span>{this.formatCurrency(rowData.actualPaid)}</span>;
    };

    gstPaidBodyTemplate = (rowData) => {
        return <span>{this.formatCurrency(rowData.gstPaid)}</span>;
    };

    actualDueBodyTemplate = (rowData) => {
        return <span>{this.formatCurrency(rowData.actualDue)}</span>;
    };

    pdcAmountBodyTemplate = (rowData) => {
        return <span>{this.formatCurrency(rowData.pdcAmount)}</span>;
    };

    pdcClearedBodyTemplate = (rowData) => {
        return <span>{this.formatCurrency(rowData.pdcCleared)}</span>;
    };

    balanceBodyTemplate = (rowData) => {
        return <span>{this.formatCurrency(rowData.balance)}</span>;
    };

    chequeAmountBodyTemplate = (rowData) => {
        return <span>{this.formatCurrency(rowData.chequeAmount)}</span>;
    };

    render() {
        const { pdcData, isLoading } = this.state;

        return (
            <div className="pdc-installment-wise-table-container">
                {isLoading && <LoadingComponent />}

                {!isLoading && (
                    <div className="pdc-table-wrapper">
                        <DataTable
                            value={pdcData}
                            scrollable
                            scrollHeight="flex"
                            className="pdc-table"
                            showGridlines
                            emptyMessage="No records to display !!!"
                        >
                            <Column
                                header="Installment Name"
                                body={this.installmentNameBodyTemplate}
                                style={{ width: '180px', minWidth: '180px' }}
                            />
                            <Column
                                header="Fee Amount (A)"
                                body={this.feeAmountBodyTemplate}
                                style={{ width: '150px', minWidth: '150px', textAlign: 'right' }}
                            />
                            <Column
                                header="Concession (B)"
                                body={this.concessionBodyTemplate}
                                style={{ width: '150px', minWidth: '150px', textAlign: 'right' }}
                            />
                            <Column
                                header="Net Amount (C=A-B)"
                                body={this.netAmountBodyTemplate}
                                style={{ width: '180px', minWidth: '180px', textAlign: 'right' }}
                            />
                            <Column
                                header="Non-GST Payable Amount (D)"
                                body={this.nonGSTPayableBodyTemplate}
                                style={{ width: '220px', minWidth: '220px', textAlign: 'right' }}
                            />
                            <Column
                                header="GST Payable Amount (E)"
                                body={this.gstPayableBodyTemplate}
                                style={{ width: '200px', minWidth: '200px', textAlign: 'right' }}
                            />
                            <Column
                                header="GST on (F)"
                                body={this.gstOnBodyTemplate}
                                style={{ width: '130px', minWidth: '130px', textAlign: 'right' }}
                            />
                            <Column
                                header="Total (G=D+E+F)"
                                body={this.totalBodyTemplate}
                                style={{ width: '150px', minWidth: '150px', textAlign: 'right' }}
                            />
                            <Column
                                header="Actual Paid (H)"
                                body={this.actualPaidBodyTemplate}
                                style={{ width: '150px', minWidth: '150px', textAlign: 'right' }}
                            />
                            <Column
                                header="GST Paid (I)"
                                body={this.gstPaidBodyTemplate}
                                style={{ width: '130px', minWidth: '130px', textAlign: 'right' }}
                            />
                            <Column
                                header="Actual Due (J=G-(H+I))"
                                body={this.actualDueBodyTemplate}
                                style={{ width: '180px', minWidth: '180px', textAlign: 'right' }}
                            />
                            <Column
                                header="PDC Amount (K)"
                                body={this.pdcAmountBodyTemplate}
                                style={{ width: '160px', minWidth: '160px', textAlign: 'right' }}
                            />
                            <Column
                                header="PDC Cleared Amount (L)"
                                body={this.pdcClearedBodyTemplate}
                                style={{ width: '200px', minWidth: '200px', textAlign: 'right' }}
                            />
                            <Column
                                header="Balance (M=J-K)"
                                body={this.balanceBodyTemplate}
                                style={{ width: '150px', minWidth: '150px', textAlign: 'right' }}
                            />
                            <Column
                                header="Cheque Amount"
                                body={this.chequeAmountBodyTemplate}
                                style={{ width: '160px', minWidth: '160px', textAlign: 'right' }}
                            />
                        </DataTable>
                    </div>
                )}
            </div>
        );
    }
}
